export default "a => {};\n(a) => {};\n(a, b) => {};"